import { companyServiceHttpClient } from "src/common/CompanyServiceHttpClient";

export class UserManageSeviceClient {
  async getUsers(
    pageIndex?: number,
    pageSize?: number,
    userName?: string,
    phoneNumber?: string,
    email?: string
  ) {
    return await companyServiceHttpClient.get("/v2/consoleadmin/users", {
      params: {
        pageIndex: pageIndex,
        pageSize: pageSize,
        userName: userName,
        phoneNumber: phoneNumber,
        email: email,
      },
    });
  }

  async getUserDetail(userId: string) {
    return await companyServiceHttpClient.get(
      `/v2/consoleadmin/users/${userId}`,
      {}
    );
  }

  async updatePassword(userId: string, payload: Record<string, string>) {
    return await companyServiceHttpClient.patch(
      `/v2/consoleadmin/users/${userId}`,
      payload,
      {}
    );
  }
}
export const UserSeviceClient = new UserManageSeviceClient();
